import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick, onMounted, computed } from 'vue';
  import { isSingleDigit } from '@/helpers/utils';

  
  const __default__ = {
    name: 'CodeInput',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    length: { type: Number, required: true },
    codeValue: { type: String, required: false },
    isEditable: { type: null, required: true }
  },
  emits: ["update:code"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:code', activationCode: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    length: number;
    codeValue?: string;
    isEditable: Boolean;
  };

  

  

  const code = computed<Array<string>>(() => {
    return props.codeValue?.split('') || Array(props.length).fill('');
  });

  const inputs = ref<HTMLInputElement[]>([]);

  function handleInput(index: number) {
    const inputVal = code.value[index];
    if (isSingleDigit(inputVal)) {
      if (index < props.length - 1) {
        nextTick(() => {
          inputs.value[index + 1].focus();
        });
      }
      emit('update:code', code.value.join(''));
    } else {
      code.value[index] = '';
    }
  }

  function handleBackspace(index: number, event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).value === '' && index > 0) {
      nextTick(() => {
        inputs.value[index - 1].focus();
      });
    }
  }

  function isNumber(evt: KeyboardEvent) {
    const char = evt.key;
    if (!isSingleDigit(char)) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

return { __sfc: true,props, emit, code, inputs, handleInput, handleBackspace, isNumber }
}

})